// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1qnua","left":"StickyBox_left__2LOMK","right":"StickyBox_right__3HRBG"};